import axios from "axios";

const API_URL = "/api/users"; // Adjust this URL to your backend API endpoint

export const getUsers = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const getUserById = async (userId) => {
  try {
    const response = await axios.get(`${API_URL}/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user:", error);
    throw error;
  }
};

const toFormData = (data) => {
  const form = new FormData();
  Object.entries(data || {}).forEach(([key, value]) => {
    if (key === 'profileFile') return; // handled below
    if (value === undefined || value === null) return;
    // For objects/arrays, stringify
    if (typeof value === 'object' && !(value instanceof File) && !(value instanceof Blob)) {
      form.append(key, JSON.stringify(value));
    } else {
      form.append(key, value);
    }
  });
  if (data?.profileFile) {
    form.append('files', data.profileFile);
    form.append('hasProfileFile', 'true');
  }
  return form;
};

export const addUser = async (userData) => {
  try {
    console.log("userData", userData);
    const form = toFormData(userData);
    const response = await axios.post(API_URL, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding user:", error);
    throw error;
  }
};

export const editUser = async (userId, userData) => {
  console.log("editUser", userData);
  try {
    const form = toFormData(userData);
    const response = await axios.put(`${API_URL}/${userId}`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    console.error("Error editing user:", error);
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const response = await axios.delete(`${API_URL}/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};
export const fetchUserPermissions = async (userId) => {
  try {
    const response = await axios.get(`${API_URL}/${userId}/permissions`);
    // console.log("user Role Permissions", response.data);

    return response.data;
  } catch (error) {
    console.error("Error fetching user permissions:", error);
    throw error;
  }
};

export const getUsersByRole = async (roleId) => {
  try {
    // NOTE: must be the /usersByRole/:roleId route — `${API_URL}/${roleId}`
    // collides with GET /:id (getUserById) and returns a single user, not a list.
    const response = await axios.get(`${API_URL}/usersByRole/${roleId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};
export const editUserPermissions = async (userId, permissions) => {
  try {
    // console.log("permissions", permissions);

    const response = await axios.put(
      `${API_URL}/${userId}/update-permissions`,
      permissions
    );
    return response.data;
  } catch (error) {
    console.error("Error editing user permissions:", error);
    throw error;
  }
};
export const getUserDirectPermissions = async (userId) => {
  // console.log(userId);

  try {
    const response = await axios.get(`${API_URL}/${userId}/direct-permissions`);
    return response.data; // Assuming the API returns the grouped permissions data directly
  } catch (error) {
    console.error("Error fetching role permissions", error);
    throw error;
  }
};

export const changeUserPassword = async (userId, password) => {
  const response = await axios.post(`${API_URL}/${userId}/change-password`, { password });
  return response.data;
};

export const quickCreateParent = async (parentData) => {
  const response = await axios.post(`${API_URL}/quick-parent`, parentData);
  return response.data;
};

export const addUserWithStudent = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/with-student`, userData)
    return response.data;
  } catch (err) {
    console.error("Error adding user with student:", err);
    throw err;
  }
}

// export const getUsersByRole = async (roleId) => {
//   try {
//     const response = await axios.get(`${API_URL}/usersByRole/${roleId}`);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching users by role:", error);
//     throw error;
//   }
// };
